module.exports = __webpack_public_path__ + "fonts/WorkSans-Italic-VariableFont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/WorkSans/WorkSans-Italic-VariableFont.ttf
// module id = 3488
// module chunks = 0